// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
  z-index: 9999;

  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-container {
  background: #fff;
  width: 95%;
  max-width: 1200px;
  height: 90vh;
  border-radius: 8px;

  display: flex;
  flex-direction: column;
  padding: 16px;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e5e7eb;
  padding-bottom: 8px;
}

.modal-actions {
  display: flex;
  gap: 10px;
}

.modal-prompt {
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  padding: 10px;
  margin: 10px 0;
  border-radius: 6px;
  font-size: 14px;
}

.export-selector {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background: #f8fafc;
  padding: 12px;
  margin: 10px 0;
}

.export-selector-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}

.export-selector-header span {
  font-size: 13px;
  color: #4b5563;
}

.export-selector-actions {
  display: flex;
  gap: 8px;
  margin-bottom: 12px;
  flex-wrap: wrap;
}

.export-selector-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 8px 12px;
  max-height: 180px;
  overflow: auto;
  padding-right: 4px;
}

.export-selector-item {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #111827;
}
`, "",{"version":3,"sources":["webpack://./src/styles/runDetailsModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;;EAEb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;;EAElB,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,aAAa;EACb,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;AAChB","sourcesContent":[".modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.55);\n  z-index: 9999;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.modal-container {\n  background: #fff;\n  width: 95%;\n  max-width: 1200px;\n  height: 90vh;\n  border-radius: 8px;\n\n  display: flex;\n  flex-direction: column;\n  padding: 16px;\n}\n\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid #e5e7eb;\n  padding-bottom: 8px;\n}\n\n.modal-actions {\n  display: flex;\n  gap: 10px;\n}\n\n.modal-prompt {\n  background: #f9fafb;\n  border: 1px solid #e5e7eb;\n  padding: 10px;\n  margin: 10px 0;\n  border-radius: 6px;\n  font-size: 14px;\n}\n\n.export-selector {\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  background: #f8fafc;\n  padding: 12px;\n  margin: 10px 0;\n}\n\n.export-selector-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 10px;\n}\n\n.export-selector-header span {\n  font-size: 13px;\n  color: #4b5563;\n}\n\n.export-selector-actions {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 12px;\n  flex-wrap: wrap;\n}\n\n.export-selector-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));\n  gap: 8px 12px;\n  max-height: 180px;\n  overflow: auto;\n  padding-right: 4px;\n}\n\n.export-selector-item {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 13px;\n  color: #111827;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
